export var COMMENT_MAX_CHARACTERS = 800;
export var EMAIL_MAX_CHARACTERS = 255;
export var NAME_MAX_CHARACTERS = 80;
export var PHONE_MAX_CHARACTERS = 15;